import { useState, useRef } from 'react';

export const useConfirmModal = () => {
  const [modal, setModal] = useState<{
    isOpen: boolean;
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    confirmButtonColor?: string;
    onConfirm?: () => void;
    onCancel?: () => void;
  }>({
    isOpen: false,
    title: '',
    message: '',
    confirmText: 'Confirmar',
    cancelText: 'Cancelar',
    confirmButtonColor: 'var(--danger-color)'
  });

  // Guardar la referencia a la promesa pendiente
  const pendingPromiseRef = useRef<((value: boolean) => void) | null>(null);

  const showConfirm = (
    title: string,
    message: string,
    options?: {
      confirmText?: string;
      cancelText?: string;
      confirmButtonColor?: string;
    }
  ): Promise<boolean> => {
    // Si ya hay una promesa pendiente, resuélvela como cancelada antes de abrir otra
    if (pendingPromiseRef.current) {
      pendingPromiseRef.current(false);
      pendingPromiseRef.current = null;
    }
    return new Promise((resolve) => {
      pendingPromiseRef.current = resolve;
      setModal({
        isOpen: true,
        title,
        message,
        confirmText: options?.confirmText || 'Confirmar',
        cancelText: options?.cancelText || 'Cancelar',
        confirmButtonColor: options?.confirmButtonColor || 'var(--danger-color)',
        onConfirm: () => {
          setModal(prev => ({ ...prev, isOpen: false }));
          if (pendingPromiseRef.current) {
            pendingPromiseRef.current(true);
            pendingPromiseRef.current = null;
          }
        },
        onCancel: () => {
          setModal(prev => ({ ...prev, isOpen: false }));
          if (pendingPromiseRef.current) {
            pendingPromiseRef.current(false);
            pendingPromiseRef.current = null;
          }
        }
      });
    });
  };

  const hideConfirm = () => {
    setModal(prev => ({ ...prev, isOpen: false }));
    if (pendingPromiseRef.current) {
      pendingPromiseRef.current(false);
      pendingPromiseRef.current = null;
    }
  };

  return { modal, showConfirm, hideConfirm };
}; 